import api from "services/api";

export async function fetchCertificates(
  pageSize = 10,
  pageNumber = 1,
  searchTerm = "",
  sortColumn = "certificateId",
  sortDirection = "ASC"
) {
  try {
    const params = {
      pageSize,
      pageNumber,
      searchTerm,
      sortColumn,
      sortDirection,
    };
    const response = await api.get(`/Certificate`, { params });
    if (response.data && Array.isArray(response.data.data)) {
      return {
        items: response.data.data,
        totalItems: response.data.totalCount || 0,
      };
    }
    return { items: [], totalItems: 0 };
  } catch (err) {
    console.error("Error fetching certificates:", err);
    return { items: [], totalItems: 0 };
  }
}

export async function getCertificatesByPersonnelId(
  personnelId,
  pageSize = 100,
  pageNumber = 1
) {
  try {
    const params = { pageSize, pageNumber };
    const response = await api.get(`/Certificate/personnel/${personnelId}`, {
      params,
    });
    return response.data;
  } catch (err) {
    console.error(
      `Error fetching certificates for personnel ${personnelId}:`,
      err
    );
    throw err;
  }
}

export async function createCertificate(data) {
  try {
    const response = await api.post("/Certificate", data);
    return response.data;
  } catch (err) {
    console.error("Error creating certificate:", err);
    throw err;
  }
}

export async function updateCertificate(id, data) {
  try {
    const response = await api.put(`/Certificate/${id}`, data);
    return response.data;
  } catch (err) {
    console.error(`Error updating certificate ${id}:`, err);
    throw err;
  }
}

export async function deleteCertificate(id) {
  try {
    const response = await api.delete(`/Certificate/${id}`);
    return response.data;
  } catch (err) {
    console.error(`Error deleting certificate ${id}:`, err);
    throw err;
  }
}

export async function deleteCertificatesByPersonnelId(personnelId) {
  try {
    const response = await api.delete(`/Certificate/personnel/${personnelId}`);
    return response.data;
  } catch (err) {
    console.error(
      `Error deleting certificates for personnel ${personnelId}:`,
      err
    );
    throw err;
  }
}

// Create a service object for named export
const certificateService = {
  fetchCertificates,
  getCertificatesByPersonnelId,
  createCertificate,
  updateCertificate,
  deleteCertificate,
  deleteCertificatesByPersonnelId,
};

export default certificateService;
